import { Component } from '@angular/core';
import { FuiLocalizationService } from 'ngx-fomantic-ui';
import fr from 'ngx-fomantic-ui/locales/fr';

@Component({
  selector: 'dc-root',
  styleUrls: ['./app.component.less'],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(public localizationService: FuiLocalizationService) {
    // Start by choosing a "fallback" language,
    // i.e. which language to use if you don't provide a certain value.
    localizationService.load('fr', fr);
  }
}
